module.exports = __webpack_public_path__ + "static/media/ic_vehicules_checked.b1b2862f.svg";